import { Dropdown, DropdownOption } from '@carsys/form'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from 'react-i18next'
import AddNewRevenueDialog from 'app/settings/components/RevenueGroups/AddNewRevenueDialog'
import { ILineTypeConfig } from './ConfigureDefaultsFrom'

interface FieldProps {
  configPerLineType: ILineTypeConfig[]
  addRevenueFunc: () => void
}

const useStyles = makeStyles(theme => ({
  boxHeader: {
    padding: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    '&>*': {
      minWidth: '200px',
      margin: theme.spacing(1),
      flex: '1 1 20%'
    }
  },
  dropdownsContainer: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  }
}))

export const ConfigureDefaultsFields: React.FC<FieldProps> = ({ configPerLineType, addRevenueFunc }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <>
      <Grid item xs={12}>
        <Paper>
          <div className={classes.boxHeader}>
            <h2>{t('workorder.workorder')}</h2>
          </div>
          <div className={classes.paper}>
            {configPerLineType
              .filter(a => a.lineType !== '')
              .map(item => {
                return (
                  <div style={{ display: 'flex' }} key={`lineType_div${item.lineType}`}>
                    <Dropdown<string>
                      key={`lineType_dropdown${item.lineType}`}
                      data-testid={`revenue-group-default-selector_${item.lineType}`}
                      name={`lineType_${item.lineType}`}
                      label={item.label}
                    >
                      {item.options.map(option => (
                        <DropdownOption key={option.value} value={option.value}>
                          {option.label}
                        </DropdownOption>
                      ))}
                    </Dropdown>
                    <AddNewRevenueDialog
                      readOnlyInitialValues={{
                        Kind: item.revenueGroupKind,
                        ProductType: item.lineType,
                        IsDefaultForProductType: true
                      }}
                      addRevenueFunc={addRevenueFunc}
                    />
                  </div>
                )
              })}
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <div className={classes.boxHeader}>
            <h2>{t('setting.vehicle_sales.name')}</h2>
          </div>
          <div className={classes.paper}>
            {configPerLineType
              .filter(a => a.vehicleSalesType !== '')
              .map(item => {
                return (
                  <div style={{ display: 'flex' }} key={`vehicleSalesType_div${item.vehicleSalesType}`}>
                    <Dropdown<string>
                      key={`vehicleSalesType_dropdown${item.vehicleSalesType}`}
                      data-testid={`revenue-group-default-selector_${item.vehicleSalesType}`}
                      name={`vehicleSalesType_${item.vehicleSalesType}`}
                      label={item.label}
                    >
                      {item.options.map(option => (
                        <DropdownOption key={option.value} value={option.value}>
                          {option.label}
                        </DropdownOption>
                      ))}
                    </Dropdown>
                    <AddNewRevenueDialog
                      readOnlyInitialValues={{
                        Kind: item.revenueGroupKind,
                        VehicleSalesType: item.vehicleSalesType,
                        IsDefaultForProductType: true
                      }}
                      addRevenueFunc={addRevenueFunc}
                    />
                  </div>
                )
              })}
          </div>
        </Paper>
      </Grid>
    </>
  )
}
